import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';

import { QaMixin } from '@/mixins/QA/QA';

export default {
  name: 'QaAnswerModal',

  mixins: [QaMixin],

  props: {
    p_id: {
      type: String,
      default: () => 'writeAnswer',
    },
  },

  computed: {
    ...mapState('Mixins/QA', {
      ms_res_doAnswerNew: 'res_doAnswerNew',
    }),

    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    ///
    c_isCanOpenQA() {
      return this.ms_qaQuestion.canPostQA;
    },
  },

  methods: {
    ...mapMutations('QA/Question', {
      mm_UPDATE_QA_QUESTION: 'UPDATE_QA_QUESTION',
      mm_PUSH_QA_TEACHER_ANSWER: 'PUSH_QA_TEACHER_ANSWER',
      mm_PUSH_QA_ANSWER: 'PUSH_QA_ANSWER',
    }),

    ...mapActions('Mixins/QA', {
      ma_doAnswerNew: 'doAnswerNew',
    }),

    ///
    openQaModal() {
      $(this.$refs.writeAnswer).modal('show');
    },

    ///
    async doPostQA() {
      await this.ma_doAnswerNew({
        questionId: this.ms_qaQuestion.qaQuestionId,
        answer: this.qaContent,
      });
    },

    ///
    doAfterPostQaSuccess() {
      const answer = {
        ..._.cloneDeep(this.ms_res_doAnswerNew.data),
        comments: [],
      };
      if (this.mg_userInfo.teacher) {
        this.mm_PUSH_QA_TEACHER_ANSWER(answer);
      } else {
        this.mm_PUSH_QA_ANSWER(answer);
      }
      this.mm_UPDATE_QA_QUESTION({
        isAnswered: true,
        numOfAnswer: this.ms_qaQuestion.numOfAnswer + 1,
      });
      this.$emit('qa-answer-posted');
    },

    ///
    closeQaModal() {
      $(this.$refs.writeAnswer).modal('hide');
    },
  },
};
